import Typography from '@repo/ui/typography'

import {
  createOrUpdateTravelExpenses,
  updateTravelExpensesCurrency
} from '../../../api/affected-staffs/create-or-update-travel-expenses'
import { getAffectedStaffTravelExpenses } from '../../../api/affected-staffs/get-affected-staff-travel-expenses'
import { sendTravelExpensesToLec } from '../../../api/affected-staffs/send-travel-expenses-to-lec'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import TravelExpenses from '../../../components/pages/travel-expenses/travel-expenses'
import useAffectedStaff from '../../../lib/hooks/use-affected-staff'
import useAuth from '../../../lib/hooks/use-auth'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { StaffRequestProperties } from '../../../lib/types/models/staff-request/properties.staff-request'

export default function StaffPersonalSpaceJourneyDetailsExpensesNote() {
  const { affectedStaff, isLoading, refetch } = useAffectedStaff()
  const { user } = useAuth()

  if (isLoading) return <LoadingScreen />
  if (!affectedStaff) return <Typography variant="text">Affected staff not found</Typography>

  return (
    <TravelExpenses
      id={affectedStaff.id}
      updateTravelExpensesCurrency={(currency) =>
        updateTravelExpensesCurrency({ id: affectedStaff.id, currency })
      }
      travelExpensesCurrency={affectedStaff.travelExpensesCurrency}
      mode={user.role === RoleEnum.ADMIN ? 'admin' : 'staff'}
      travelExpensesStatus={affectedStaff.travelExpensesStatus}
      travelExpensesSentAt={affectedStaff.travelExpensesSentAt}
      isForeignStaff={StaffRequestProperties.isForeignStaff(affectedStaff.staffRequest)}
      createOrUpdateTravelExpenses={createOrUpdateTravelExpenses}
      sendTravelExpensesToLec={sendTravelExpensesToLec}
      getTravelExpenses={getAffectedStaffTravelExpenses}
      onSuccess={async () => {
        await refetch()
      }}
    />
  )
}
